export default function initRandomPinPulse() {
  const pins = document.querySelectorAll('.map .pin');
  if (pins.length === 0) return;

  pins.forEach((pin) => {
    const randomDuration = (Math.random() * 2 + 1).toFixed(2); // 1s to 3s
    const randomDelay = (Math.random() * 3).toFixed(2); // 0s to 3s

    pin.style.animation = `pulse-animation ${randomDuration}s ease-in-out ${randomDelay}s infinite`;
  })
}